/**
 * Main JavaScript file for the child theme.
 */


// Make sure we don't try to expose the Babel polyfill globally as that is already done by the main script
global._babelPolyfill = false;

// Module imports
import 'babel-polyfill';
import { Theming } from "theming/theming.js";
import { ParallaxClass } from "modules/parallax/parallax.jsx";


// Add event listeners
Theming.addListeners();
ParallaxClass.addListeners();



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite-child/assets/js/main.js